import { createSlice } from '@reduxjs/toolkit';
import { Toast } from 'primereact/toast';
import { RefObject } from 'react';

type TToast = {
  ref: RefObject<Toast | null> | null;
};
const initialState: TToast = {
  ref: null,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    setToastRef: (state, action) => {
      state.ref = action.payload;
    },
  },
});
export const { setToastRef } = toastSlice.actions;
export default toastSlice.reducer;
